import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontMedium } from 'src/styles/font';

import { MediaBP as MQ } from '../../styles/mediaQuery';
export const popupScreen = css`
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
`;
export const popupPlacer = css`
  background: ${colors.white};
  margin: auto;
  left: 0;
  top: 50%;
  bottom: 50%;
  border-radius: 12px;
`;
export const popupWrapper = css`
  ${MQ.MediaXsMaxWidth} {
    padding: 24px 16.5px;
  }
  padding: 24px 26.5px;
`;
export const closeIconWrapper = css`
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
`;
export const closeIconImage = css`
  height: 16px;
  width: 16px;
`;
export const title = css`
  ${ZeeFontBold(18, 26)};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  text-align: center;
`;
export const desc = css`
  margin-top: 16px;
  align-items: center;
  justify-content: center;
  ${ZeeFontMedium(14, 22)};
  color: ${colors.AccentInfoPopupDescriptionMobileColor};
  text-align: center;
`;
export const footerWrapper = css`
  display: flex;
  justify-content: center;
  padding: 24px 27.5px;
  flex-direction: column;
`;
export const btnClass = css`
  display: flex;
  justify-content: center;
  padding: 8px;
  min-width: 220px;
  width: auto;
  height: 36px;
  background: ${colors.white};
  border-radius: 6px;
  border: 1px solid;
  color: ${colors.VioletRed};
  font-size: 14px;
  cursor: pointer;
  align-items: center;
  box-sizing: border-box;
`;
